import { ScrollArea } from '@base-ui/react/scroll-area';
import styled from 'styled-components';

import { Colour, Shadow } from '@xemplo/style-constants';

import { ListCssVar } from '../../utils/types/stateful-list.types';

export const ListWrapper = styled.div`
  ${ListCssVar.WrapperHeight}: 100%;
  ${ListCssVar.WrapperWidth}: auto;
  ${ListCssVar.ScrollAreaHeight}: 300px;

  position: relative;
  background: transparent;
  ${Shadow.Medium1};
  border: 1px solid ${Colour.Gray[200]};
  border-radius: 8px;
  width: var(${ListCssVar.WrapperWidth});
`;

export const ScrollAreaRoot = styled(ScrollArea.Root)`
  height: var(${ListCssVar.ScrollAreaHeight});
  width: 100%;
`;

export const ScrollAreaViewport = styled(ScrollArea.Viewport)`
  border-radius: 8px;
  height: 100%;
  outline: none;
  outline-offset: -1px;
  overscroll-behavior: contain;

  &.no-border-radius {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

/**
 * The min-width requires that because the base-ui has an inline
 * min-width set to fit-content, which causes issues deterimining
 * the width for the text ellipsis functionality. Not sure if there's
 * a better way to handle this, but this works for now.
 */
export const ScrollAreaContent = styled(ScrollArea.Content)`
  display: flex;
  flex-direction: column;
  min-width: unset !important;
`;

export const ScrollAreaScrollbar = styled(ScrollArea.Scrollbar)`
  display: flex;
  justify-content: center;
  background-color: transparent;
  width: 4px;
  border-radius: 2px;
  margin: 4px;
  opacity: 0;
  transition: opacity 150ms 300ms;

  &[data-hovering],
  &[data-scrolling] {
    opacity: 1;
    transition-duration: 75ms;
    transition-delay: 0ms;
  }

  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 100%;
  }
`;

export const ScrollAreaThumb = styled(ScrollArea.Thumb)`
  width: 100%;
  border-radius: inherit;
  background-color: ${Colour.Dark[10]};
`;
